import { ObjectOfStrings, QuestionSchema } from '../../reducers/types';
import codes from '../../utils/constants/codes';

const addStyleToSpecificQuestion = (
    question: QuestionSchema,
    specificStyleToQuestion: ObjectOfStrings,
): string => {
    return question.code === specificStyleToQuestion.code
        ? specificStyleToQuestion['style']
        : specificStyleToQuestion['defaultStyle'];
};
const findQuestionCode = (
    question: QuestionSchema,
    code: string | null | undefined,
): boolean => {
    return question?.code === code;
};
const isDisableSpecificQuestion = (
    question: QuestionSchema,
    isDisabled: ObjectOfStrings | undefined,
): boolean => {
    return isDisabled && isDisabled.code
        ? question.code === isDisabled.code
        : false;
};

export {
    findQuestionCode,
    addStyleToSpecificQuestion,
    isDisableSpecificQuestion,
};
